export default __webpack_public_path__ + "static/media/canopy_sunrise.4127c391.jpg";